<template>
  <ValidationObserver rules="required" v-slot="{ handleSubmit }">
    <RightSideBar
      v-if="isOpen"
      @close="$emit('close')"
      @submit="handleSubmit(handleSave)"
      submit="Save"
      cancel="Cancel"
      button-class="bg-dynamicBackBtn text-white"
      padding="padding: 0 0.75rem"
    >
      <template v-slot:title>
        <div class="flex items-center text-darkPurple w-full">
          <back-button
            variant="secondary"
            @onClick="$emit('close')"
            class="mr-3"
          />
          <h2 class="font-bold text-lg">
            {{ isEdit ? "Edit Job Cadre" : "Add New Job Cadre" }}
          </h2>
        </div>
      </template>

      <div class="pt-1">
        <div class="mb-4">
          <c-text
            label="Job Cadre"
            placeholder="--Enter--"
            variant="w-full h-10"
            v-model="form.cadre"
            :rules="['required']"
          />
        </div>

        <div>
          <label class="label block mb-2">Description</label>
          <c-textarea
            placeholder="Text Area"
            variant="w-full"
            :maxlength="300"
            v-model="form.description"
          />
          <p class="text-right text-xs text-romanSilver mt-1">
            {{ descriptionLength }}/300 characters
          </p>
        </div>
      </div>
    </RightSideBar>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CTextarea from "@scelloo/cloudenly-ui/src/components/text-area";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import RightSideBar from "@/components/RightSideBar";

export default {
  name: "CadreDrawer",
  components: {
    ValidationObserver,
    CText,
    CTextarea,
    BackButton,
    RightSideBar,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        cadre: "",
        description: "",
      },
    };
  },
  computed: {
    descriptionLength() {
      return this.form.description ? this.form.description.length : 0;
    },
  },
  watch: {
    isOpen(value) {
      if (!value) {
        return;
      }
      this.form = {
        cadre: this.initialData?.cadre || "",
        description: this.initialData?.description || "",
      };
    },
  },
  methods: {
    handleSave() {
      this.$emit("save", {
        ...this.form,
        id: this.initialData?.id || null,
        isEdit: this.isEdit,
      });
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 14px;
  color: #2d3142;
}
</style>